import { Collection } from "../base/collection";

export class MyRecord extends Collection {
  constructor() {
    super();
    this.name = "MyRecord";
  }

  async getMyRecords(): Promise<any> {
    this.url = "/cms/api/my-record/info";
    return await this.fetch();
  }
}
